<template>
  <div>
    <!--动态 映射键值对组件，可以添加、删除行，拖拽排序-->
    <draggable v-model="localRowData" item-key="index" @end="handleDragEnd" handle=".handle_drop" :animation="200" ghost-class="ghost" chosen-class="chosen" drag-class="dragging">
            <div v-for="(item, index) in localRowData" :key="index" class="flex_input">
              <!--输入框-->
                <el-form :ref="el => setFormRef(el, index)" :model="item" :inline="true" label-position="top" :rules="mappingRule">
                    <el-form-item :label="bitOrValue === '1'? '映射值(二进制字符串)' : '映射值'" prop="key">
                      <el-input size="small" v-model="item.key" placeholder="请输入映射值" />
                    </el-form-item>
                    <el-form-item label="映射内容" prop="value">
                      <el-input size="small" v-model="item.value" placeholder="请输入映射内容" />
                    </el-form-item>
                </el-form>
                <!--编辑图表，包含增加，删除，拖拽-->
                <div id="operateRowBtn">
                  <el-tooltip content="新建行" effect="light" placement="top">
                    <el-button link type='text' icon="el-icon-circle-plus-outline" @click="addRow(index)" />
                  </el-tooltip>
                  <el-tooltip content="移除行" effect="light" placement="top">
                    <el-button link type='text' icon="el-icon-remove-outline" @click="removeRow(index)" />
                  </el-tooltip>
                  <el-tooltip content="上下拖动排序" effect="light" placement="top">
                    <el-button link type='text' icon="el-icon-sort handle_drop" style="cursor: grab;" />
                  </el-tooltip>
                </div>
            </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mappingRule } from '@/data/rules'

export default {
  name: 'DynamicRows',
  components: {
    draggable,
  },
  // 接收父组件传过来的行数据rowData
  props: {
    rowData: {
      type: Array,
      required: true
    },
    bitOrValue: {
      type: String,
      default: '1'
    }
  },
  watch: {
    // 监听本地行数据localRowData
    rowData: {
      handler (val) {
        this.localRowData = val
      },
      deep: true
    }
  },
  data () {
    return {
      // 本地行数据 (修复拼写)
      localRowData: this.rowData,
      // 表单校验规则
      mappingRule: mappingRule,
      // 存储每个表单的引用
      formRefs: []
    }
  },
  beforeDestroy() {
    // 组件销毁时清空引用，避免内存泄漏
    this.formRefs = [];
  },
  methods: {
    // 设置表单引用
    setFormRef(el, index) {
      if (el) {
        // 确保数组长度足够
        if (index >= this.formRefs.length) {
          this.formRefs.length = index + 1;
        }
        this.formRefs[index] = el;
      }
    },
    // 通知父组件行数据发生变化
    updateParent () {
      // 直接传递数据，不再添加额外属性 (关键修复)
      this.$emit('update:row-data', this.localRowData)
    },
    // 新增一行
    addRow (index) {
      this.$emit('addRow', index)
    },
    // 删除一行
    removeRow (index) {
      this.$emit('removeRow', index)
    },
    // 拖拽排序
    handleDragEnd () {
      this.updateParent()
    },
    // 表单校验
    handleValidation () {
      // 过滤掉无效引用
      const validRefs = this.formRefs.filter(ref => ref && typeof ref.validate === 'function');
      // 执行所有表单校验
      const promises = validRefs.map(ref => ref.validate());
      return Promise.all(promises);
    }
  }
}
</script>
<style scoped>
.flex_input{
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-incon-rank{
  height: 25px;
  width: 25px;
  margin: 5px;
}

.handle_drop{
  cursor: grab;
}

.input_arry{
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: start;
  margin-right: 5px;
}

.text_hint{
  font-size: 12px;
  font-weight: bold;
  color: #999999;
}

/* 占位符（拖动时预留的空位） */
.ghost {
  opacity: 0.8;
  background: #c8ebfb;
  border: 1px dashed #00d8c3;
}

/* 被拖动的原始元素 */
.chosen {
  background: #f0f7ff;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
}

/* 跟随鼠标的克隆元素 */
.dragging {
  background: #e6f7ff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transform: rotate(3deg); /* 轻微旋转效果 */
  z-index: 9999 !important;
}

#operateRowBtn{
  margin-top: 30px;
}
</style>
